export default "__VITE_ASSET__Dbk2AquN__"